import { TApiTaskComment } from "@timenotes/shared/src/services/api-client/types"
import { useSettingsDateFormat } from "@timenotes/shared/src/services/settings/queries/use-settings-date-format"
import { Card } from "antd"
import { UserCircle } from "./task-assignees-select-popover"
import { useCommentFormik } from "@timenotes/shared/src/services/comments/queries/use-comment-formik"
import { TaskCommentOptions } from "../task-comment-options"
import { GenericButtonsListWrapper } from "pages/projects/board/components/styled-components/generic-buttons-list-wrapper"
import { formatRichText } from "utils/formatRichText"


interface Props {
  projectId: string
  taskId: string
  comment: TApiTaskComment
}

export const TaskComment = (props: Props) => {
  const {
    projectId,
    taskId,
    comment
  } = props

  const {
    dateToDateTimeString
  } = useSettingsDateFormat()

  return (
    <div
      style={{
        display: 'flex',
      }}
    >
      <div
        style={{
          padding: '10px',
          paddingTop: '20px',
        }}
      >
        <UserCircle>
          { comment.author.firstName[0] }{ comment.author.lastName[0] }
        </UserCircle>
      </div>

      <Card
        style={{ 
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex'
          }}
        >
          <span
            style={{
              marginRight: '5px',
            }}
          >
            <b>
              { comment.author.firstName } { comment.author.lastName }
            </b>
          </span>

          <span
            style={{
              fontSize: '0.75rem',
              paddingTop: '2px',
            }}
          >
            { dateToDateTimeString(comment.createdAt) }
          </span>

          <span
            style={{
              marginLeft: 'auto'
            }}
          >
            <GenericButtonsListWrapper>
              <TaskCommentOptions 
                projectId={projectId}
                taskId={taskId}
                commentId={comment.id}
              />
            </GenericButtonsListWrapper>
          </span>
        </div>

        <div>
          { formatRichText(comment.content) }
        </div>

      </Card>
    </div>
  )
}